export enum ServiceCodes {
    HubPowerQuery = 0,
    HubApiApplication,
    HubDashBoard,
    HubEncryption,
    HubHdsEncryption,
    HubTchat,
    HubSmsSending,
}
